import StoreLayout from '../../layouts/StoreLayout.vue'
import brand from '@/brand'

export default [
  {
    path: '/checkout',
    component: StoreLayout,
    children: [
      {
        path: '',
        redirect: '/checkout/cart'
      },
      {
        path: 'cart',
        name: 'checkout.cart',
        component: () => import('../../views/checkout/CartView.vue'),
        meta: {
          title: `Nákupný košík - ${brand.siteName}`,
          requiresCart: true
        }
      },
      {
        path: 'personal-info',
        name: 'checkout.personal-info',
        component: () => import('../../views/checkout/PersonalInfoView.vue'),
        meta: {
          title: `Osobné údaje - ${brand.siteName}`,
          requiresCart: true,
          step: 1
        }
      },
      {
        path: 'shipping-payment',
        name: 'checkout.shipping-payment',
        component: () => import('../../views/checkout/ShippingAndPaymentView.vue'),
        meta: {
          title: `Doprava a platba - ${brand.siteName}`,
          requiresCart: true,
          step: 2
        }
      },
      {
        path: 'review',
        name: 'checkout.review',
        component: () => import('../../views/checkout/ReviewOrderView.vue'),
        meta: {
          title: `Zhrnutie - ${brand.siteName}`,
          requiresCart: true,
          step: 3
        }
      },
      {
        path: 'payment-return/:orderNumber',
        name: 'checkout.payment-return',
        component: () => import('../../views/checkout/PaymentReturnView.vue'),
        meta: {
          title: `Overenie platby - ${brand.siteName}`
        }
      },
      {
        path: 'thank-you/:orderNumber?',
        name: 'checkout.thank-you',
        component: () => import('../../views/checkout/ThankYouView.vue'),
        meta: {
          title: `Ďakujeme za objednávku - ${brand.siteName}`
        }
      }
    ]
  }
]